import { PROYECT, api_get, api_post, api_put, api_delete } from "../../../services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../../actions/search/searchActions";

export const FETCH_COVERAGE_GROUPS_REQUEST = 'FETCH_COVERAGE_GROUPS_REQUEST';
export const FETCH_COVERAGE_GROUPS_SUCCESS = 'FETCH_COVERAGE_GROUPS_SUCCESS';
export const FETCH_COVERAGE_GROUPS_FAILURE = 'FETCH_COVERAGE_GROUPS_FAILURE';

export const FETCH_COVERAGES_BY_GROUP_REQUEST = 'FETCH_COVERAGES_BY_GROUP_REQUEST';
export const FETCH_COVERAGES_BY_GROUP_SUCCESS = 'FETCH_COVERAGES_BY_GROUP_SUCCESS';
export const FETCH_COVERAGES_BY_GROUP_FAILURE = 'FETCH_COVERAGES_BY_GROUP_FAILURE';

export const FETCH_COVERAGE_GROUP_BY_ID_REQUEST = 'FETCH_COVERAGE_GROUP_BY_ID_REQUEST';
export const FETCH_COVERAGE_GROUP_BY_ID_SUCCESS = 'FETCH_COVERAGE_GROUP_BY_ID_SUCCESS';
export const FETCH_COVERAGE_GROUP_BY_ID_FAILURE = 'FETCH_COVERAGE_GROUP_BY_ID_FAILURE';

export const CREATE_COVERAGE_GROUP_REQUEST = 'CREATE_COVERAGE_GROUP_REQUEST';
export const CREATE_COVERAGE_GROUP_SUCCESS = 'CREATE_COVERAGE_GROUP_SUCCESS';
export const CREATE_COVERAGE_GROUP_FAILURE = 'CREATE_COVERAGE_GROUP_FAILURE';

export const EDIT_COVERAGE_GROUP_REQUEST = 'EDIT_COVERAGE_GROUP_REQUEST';
export const EDIT_COVERAGE_GROUP_SUCCESS = 'EDIT_COVERAGE_GROUP_SUCCESS';
export const EDIT_COVERAGE_GROUP_FAILURE = 'EDIT_COVERAGE_GROUP_FAILURE';

export const DELETE_COVERAGE_GROUP_REQUEST = 'DELETE_COVERAGE_GROUP_REQUEST';
export const DELETE_COVERAGE_GROUP_SUCCESS = 'DELETE_COVERAGE_GROUP_SUCCESS';
export const DELETE_COVERAGE_GROUP_FAILURE = 'DELETE_COVERAGE_GROUP_FAILURE';

export const SET_SELECTED_COVERAGE_GROUP = 'SET_SELECTED_COVERAGE_GROUP';
export const ADD_COVERAGE_GROUP_MODE = 'ADD_COVERAGE_GROUP_MODE';
export const EDIT_COVERAGE_GROUP_MODE = 'EDIT_COVERAGE_GROUP_MODE';
export const DELETE_COVERAGE_GROUP_MODE = 'DELETE_COVERAGE_GROUP_MODE';
export const CLEAR_COVERAGE_GROUPS = 'CLEAR_COVERAGE_GROUPS';

const getUrlCoverageGroups = (stationID) =>
    `${process.env.REACT_APP_URL}${PROYECT}/polygon_groups?stations=${stationID}`;

const getUrlCoverageGroupsBase = () =>
    `${process.env.REACT_APP_URL}${PROYECT}/polygon_groups`;

const getUrlCoveragesByCoverageGroup = (stationID, type = '') => {
    const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/routes/polygons/stations/${stationID}`;
    return type ? `${baseUrl}?type=${type}` : baseUrl;
};

const getUrlCoverageGroupById = (id) =>
    `${process.env.REACT_APP_URL}${PROYECT}/polygon_groups/${id}`;

export const fetchCoverageGroups = (stationId) => {
  return async (dispatch) => {
    dispatch(startRequestComp('fetchCoverageGroups'));
    try {
      const response = await api_get(getUrlCoverageGroups(stationId));
      
      dispatch({
        type: FETCH_COVERAGE_GROUPS_SUCCESS,
        payload: response || []
      });

      dispatch(stopRequestComp('fetchCoverageGroups'));
    } catch (error) {
      console.error(error);
      dispatch({
        type: FETCH_COVERAGE_GROUPS_FAILURE,
        payload: error.message
      });
      dispatch(setSnackbar("Error al obtener las agrupaciones de coberturas"));
      dispatch(stopRequestComp('fetchCoverageGroups'));
    }
  };
};

export const fetchCoveragesByCoverageGroup = (stationId, type = '') => {
  return async (dispatch) => {
    dispatch(startRequestComp('fetchCoveragesByCoverageGroup'));
    try {
      const response = await api_get(getUrlCoveragesByCoverageGroup(stationId, type));

      dispatch({
        type: FETCH_COVERAGES_BY_GROUP_SUCCESS,
        payload: response || []
      });

      dispatch(stopRequestComp('fetchCoveragesByCoverageGroup'));
    } catch (error) {
      console.error(error);
      dispatch({
        type: FETCH_COVERAGES_BY_GROUP_FAILURE,
        payload: error.message
      });
      dispatch(setSnackbar("Error al obtener las coberturas disponibles"));
      dispatch(stopRequestComp('fetchCoveragesByCoverageGroup'));
    }
  };
};

export const fetchCoverageGroupById = (id) => {
  return async (dispatch) => {
    dispatch(startRequestComp('fetchCoverageGroupById'));
    try {
      const response = await api_get(getUrlCoverageGroupById(id));

      dispatch({
        type: FETCH_COVERAGE_GROUP_BY_ID_SUCCESS,
        payload: response
      });

      dispatch(stopRequestComp('fetchCoverageGroupById'));
      return response;
    } catch (error) {
      console.error(error);
      dispatch({
        type: FETCH_COVERAGE_GROUP_BY_ID_FAILURE,
        payload: error.message
      });
      dispatch(setSnackbar("Error al obtener los detalles de la agrupación de coberturas"));
      dispatch(stopRequestComp('fetchCoverageGroupById'));
      return null;
    }
  };
};

export const createNewCoverageGroup = (data, handleClose) => {
  return async (dispatch) => {
    dispatch(startRequestComp('createCoverageGroup'));
    try {
      const response = await api_post(getUrlCoverageGroupsBase(), data);

      dispatch({
        type: CREATE_COVERAGE_GROUP_SUCCESS,
        payload: response
      });

      dispatch(setSnackbar('La agrupación de coberturas se ha guardado con éxito', 'success'));
      
      if (handleClose) handleClose();
      
      dispatch(fetchCoverageGroups(data.id_station));
      
      dispatch(stopRequestComp('createCoverageGroup'));
    } catch (error) {
      console.error(error);
      
      const errorMessage = error 
        || "Error al crear la agrupación de coberturas";
      
      dispatch({
        type: CREATE_COVERAGE_GROUP_FAILURE,
        payload: errorMessage
      });
      dispatch(setSnackbar(errorMessage));
      dispatch(stopRequestComp('createCoverageGroup'));
    }
  };
};

export const editCoverageGroup = (id, data, handleClose) => {
  return async (dispatch) => {
    dispatch(startRequestComp('editCoverageGroup'));
    try {
      const response = await api_put(getUrlCoverageGroupById(id), data);

      dispatch({
        type: EDIT_COVERAGE_GROUP_SUCCESS,
        payload: response
      });

      dispatch(setSnackbar('La agrupación de coberturas se ha modificado con éxito', 'success'));
      
      if (handleClose) handleClose();
      
      dispatch(fetchCoverageGroups(data.id_station));
      
      dispatch(stopRequestComp('editCoverageGroup'));
    } catch (error) {
      console.error(error);
      
      const errorMessage = error
        || "Error al modificar la agrupación de coberturas";
      
      dispatch({
        type: EDIT_COVERAGE_GROUP_FAILURE,
        payload: errorMessage
      });
      dispatch(setSnackbar(errorMessage));
      dispatch(stopRequestComp('editCoverageGroup'));
    }
  };
};

export const deleteCoverageGroup = (id, setOpenDelete) => {
  return async (dispatch, getState) => {
    dispatch(startRequestComp('deleteCoverageGroup'));
    try {
      const url = `${getUrlCoverageGroupsBase()}/${id}`;
      await api_delete(url);

      dispatch({
        type: DELETE_COVERAGE_GROUP_SUCCESS,
        payload: id
      });

      dispatch(setSnackbar('La agrupación de coberturas se ha eliminado con éxito', 'success'));
      
      if (setOpenDelete) setOpenDelete(false);

      const state = getState();
      const stationId = state.search.stationsSelected.id;
      if (stationId) {
        dispatch(fetchCoverageGroups(stationId));
      }
      
      dispatch(stopRequestComp('deleteCoverageGroup'));
    } catch (error) {
      console.error(error);

      const errorMessage = error 
        || "Error al eliminar la agrupación de coberturas";
      
      dispatch({
        type: DELETE_COVERAGE_GROUP_FAILURE,
        payload: errorMessage
      });
      dispatch(setSnackbar(errorMessage));
      dispatch(stopRequestComp('deleteCoverageGroup'));
    }
  };
};

export const setSelectedCoverageGroup = (coverageGroup) => ({
  type: SET_SELECTED_COVERAGE_GROUP,
  payload: coverageGroup
});

export const addCoverageGroupMode = () => ({
  type: ADD_COVERAGE_GROUP_MODE
});

export const editCoverageGroupMode = () => ({
  type: EDIT_COVERAGE_GROUP_MODE
});

export const deleteCoverageGroupMode = () => ({
  type: DELETE_COVERAGE_GROUP_MODE
});

export const clearCoverageGroups = () => ({
  type: CLEAR_COVERAGE_GROUPS
});
